export function getErrorCodeFromStatus(status) {
    // 400 errors are bad requests, 500 errors are bad responses, and
    // everything else is probably a bad validation function
    return (["ERR_BAD_REQUEST", "ERR_BAD_RESPONSE"][Math.floor(status / 100) - 4] ||
        "ERR_BAD_OPTION");
}
